import { UtilityCyclesPage } from '@/components/billing/utility-cycles-page'

export function CommitteeBillingUtilityCycles() {
  return <UtilityCyclesPage basePath="/committee/billing" />
}
